import Locations from "../../components/locations";
import { Outlet, useLocation } from "react-router";
import Layout from "../../layout/main";
import StackKit from "@/shared/components/kit/stack";
/**
 * LocationPages
 *
 * مدیریت نمایش صفحات مربوط به مکان‌ها. در مسیر اصلی "/locations"، کامپوننت لیست مکان‌ها را نمایش می‌دهد و برای مسیرهای فرعی، از Outlet برای رندرینگ صفحات فرزند استفاده می‌کند.
 *
 * @returns JSX.Element
 */
// Task Response:

// کد درست و بهینه است. پیشنهادات بهبود:
// 1. می‌توان برای readability مسیر اصلی و مسیرهای فرعی از useMatch به جای مقایسه رشته استفاده کرد:
//    const isExactCreditsPage = useMatch("/locations");
// 2. افزودن padding یا margin responsive برای StackKit برای موبایل می‌تواند تجربه کاربری را بهبود دهد.


const LocationPages = () => {
  const location = useLocation();

  const isExactCreditsPage = location.pathname === "/locations";

  return (
    <Layout>
      <StackKit direction={"column"} sx={{width: "100%",maxWidth: "1740px",gap: 10,}}>
        {isExactCreditsPage ? <Locations /> : <Outlet />}
      </StackKit>
    </Layout>
  );
};

export default LocationPages;
